// General Purpose fetch
// eslint-disable-next-line import/prefer-default-export
import { fetch } from 'whatwg-fetch';
import Cookies from 'js-cookie';

export async function makeRequest(
  url,
  requestMethod = 'GET',
  requestHeaders,
  requestBody,
) {
  const xsrfToken = decodeURIComponent(Cookies.get('XSRF-TOKEN'));
  let headers = requestHeaders;

  if (requestMethod === 'POST') {
    headers = {
      'X-CSRF-Token': getCSRFToken(),
      'X-XSRF-Token': xsrfToken,
      ...headers,
    };
  }

  return fetch(url, {
    method: requestMethod,
    headers,
    body: requestBody,
    credentials: 'same-origin',
  }).then((response) => {
    if (response.ok) {
      return response;
    }
    throw response;
  });
}

export async function makeRequestRefactored(
  url,
  requestMethod = 'GET',
  requestHeaders = {},
  requestBody = null,
  signal = undefined,
) {
  const xsrfToken = decodeURIComponent(Cookies.get('XSRF-TOKEN'));
  const meta = document.querySelector('meta[name="csrf-token"]');
  const csrfToken = meta?.getAttribute('content');

  const isMutatingRequest = ['POST', 'PUT', 'PATCH', 'DELETE'].includes(requestMethod.toUpperCase());
  const headers = {
    Accept: 'application/json',
    ...(isMutatingRequest && {
      'X-CSRF-Token': csrfToken,
      'X-XSRF-Token': xsrfToken,
    }),
    ...requestHeaders,
  };

  const options = {
    method: requestMethod,
    headers,
    body: isMutatingRequest ? JSON.stringify(requestBody) : null,
    credentials: 'same-origin',
    signal: signal ?? undefined,
  };

  if (!options.body || requestMethod === 'GET') {
    delete options.body;
  }

  return fetch(url, options)
    .then(async (response) => {
      if (response.ok) {
        const contentType = response.headers.get('Content-Type') || '';
        if (contentType.includes('application/json')) {
          return response.json();
        }
        return response;
      }

      const errorResponse = await response.json().catch(() => ({}));
      throw errorResponse;
    });
}

export function htmlToElement(html) {
  const template = document.createElement('template');
  template.innerHTML = html.trim();
  return template.content.firstChild;
}

function getCSRFToken() {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta?.getAttribute('content');
}
